import React, { useContext, useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Typography,
  DialogContentText,
  Box,
  makeStyles,
  CircularProgress,
} from "@material-ui/core";
import { UserDataContext } from "../Contexts/UserDataContext";
import { getWeekDates } from "../GlobalFunctions";
import { invoiceStatuses } from "../Mappings";
import InvoicePreviewTable from "./InvoicePreviewTable";
const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  flexColContainer: {
    display: "flex",
    flexDirection: "column",
  },
  flexColItem: {
    margin: theme.spacing(1, 0, 0, 0),
  },
  feedback: {
    maxHeight: "160px",
  },
  loading: {
    display: "flex",
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    alignItems: "center",
    justifyContent: "center",
  }
}));

const ConfirmSubmitDialog = (props) => {
  const { open, setOpen, truckId, week } = props;
  const { userData, setUserData } = useContext(UserDataContext);
  const { startDate, endDate } = getWeekDates(week);
  const [previewFetched, setPreviewFetched] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [feedback, setFeedback] = useState("");
  const classes = useStyles();

  const sendSubmitRequest = async () => {
    console.log("submitting");
    const req = {
      method: "POST",
      url: `invoices/submit/${truckId}/${startDate.toISOString()}/${endDate.toISOString()}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
    };
    try {
      setSubmitting(true);
      await axios(req);
      setOpen(false);
      setUserData({
        ...userData,
        invoiceStatuses: {
          ...userData.invoiceStatuses,
          [truckId]: {
            ...userData.invoiceStatuses[truckId],
            [week]: invoiceStatuses.submitted,
          },
        },
      });
      console.log("submitted");
    } catch (err) {
      console.log(err);
      setFeedback(err.response.data.message);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {}, []);

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!submitting) {
          setOpen(false);
        }
      }}
    >
      
      <DialogTitle>Really submit this week's data?</DialogTitle>
      <Divider />
      <DialogContent>
        <Typography>
          You are about to submit all DPC data for the week
        </Typography>
        <Typography>
          {`
          ${startDate.toLocaleDateString(
            "en-GB"
          )} → ${endDate.toLocaleDateString("en-GB")}
          `}
        </Typography>
        <Typography>
          for manager's approval, are you sure you want to do this?
        </Typography>
      </DialogContent>
      <DialogContent>
        <InvoicePreviewTable
          truckId={truckId}
          week={week}
          setFetched={setPreviewFetched}
        />
      </DialogContent>
      {feedback !== "" ? (
        <Box border={1} borderRadius={4} borderColor={"error.main"}>
          <DialogContent className={classes.feedback}>
            <DialogContentText>
              {feedback || "An unspecified error has occurred."}
            </DialogContentText>
          </DialogContent>
        </Box>
      ) : (
        <Divider />
      )}
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setOpen(false);
            setPreviewFetched(false);
          }}
          disabled={submitting || !previewFetched}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            sendSubmitRequest();
          }}
          disabled={submitting || !previewFetched}
        >
          Submit
        </Button>
      </DialogActions>
      {!previewFetched &&
        <Box className={classes.loading}>
          <CircularProgress size={120} />
        </Box>
      }
    </Dialog>
  );
};

export default ConfirmSubmitDialog;
